import { createReducer } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import appReducer from "./appReducer";
import embedMetaReducer from "./embedMetaReducer";
import metaReducer from "./metaReducer";
import navigationEntityReducer from "./navigationEntityReducer";
import pageListReducer from "./pageListReducer";
import type { CanvasWidgetsReduxState } from "./canvasWidgetsReducer";

const entityReducer = combineReducers({
  canvasWidgets: createReducer({} as CanvasWidgetsReduxState, () => {}),
  pageList: pageListReducer,
  meta: metaReducer,
  embedPropsMeta: embedMetaReducer,
  navigationEntityMeta: navigationEntityReducer,
  app: appReducer,
});

export type EntitiesState = ReturnType<typeof entityReducer>;

export default entityReducer;
